import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-530727de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title_event" }
const _hoisted_3 = { class: "certif" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "sub-name" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = ["href"]

import { firestoreDb, storageRef } from "@/config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { onMounted, watch, ref } from "vue";
import { useRoute } from "vue-router";
import Breakpoints from "@/services/Breakpoints";
import { getStorage, getDownloadURL } from "firebase/storage";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const certificateData = ref();
const dominio = ref(process.env.VUE_APP_FIREBASE_EVENT);
const date = ref();
const { type } = Breakpoints();

onMounted(async () => {
  const certificate = await getCertificate(
    route.params.eventId.toString(),
    route.params.programId.toString(),
    route.params.userId.toString()
  );
  certificateData.value = certificate.data();
  date.value = (certificateData.value?.certificateDate).toDate().toDateString();
});

async function getCertificate(
  eventId: string,
  programId: string,
  userId: string
) {
  const certificateDocRef = doc(
    firestoreDb,
    "events",
    eventId,
    "certificate-documents",
    programId,
    "participants",
    userId
  );
  const docSnap = await getDoc(certificateDocRef);
  return docSnap;
}

async function downloadCertificate() {
  const certificate = await getDownloadURL(
    storageRef(certificateData.value?.certificatePath)
  );
  window.open(certificate, "_blank");
}
watch(
  () => route.params,
  async (params) => {
    const eventId = params.eventId;
    const programId = params.programId;
    const userId = params.userId;
    const certificate = await getCertificate(
      eventId.toString(),
      programId.toString(),
      userId.toString()
    );
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(certificateData.value?.participant.eventName), 1),
    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("title")), 1),
    _createVNode(_component_v_card, {
      class: _normalizeClass(["card", 'card-' + _unref(type)])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_avatar, {
          id: "avatar",
          size: "200",
          class: "profile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              large: "",
              src: certificateData.value?.participant.profileImage
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              xs: "12",
              md: "12",
              lg: "12",
              xl: "12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_4, _toDisplayString(certificateData.value?.participant.fullName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              xs: "12",
              md: "7",
              lg: "7",
              xl: "7"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "container sub-container" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.$t("paragraph1")) + " ", 1),
                      _createElementVNode("strong", null, _toDisplayString(certificateData.value?.participant.fullName), 1)
                    ]),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(date.value), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("paragraph2")) + " " + _toDisplayString(certificateData.value?.participant.fullName) + " " + _toDisplayString(_ctx.$t("paragraph3")), 1),
                    _createElementVNode("a", {
                      class: "text",
                      href: 
                'https://' +
                dominio.value +
                '/' +
                certificateData.value?.participant.eventID
              ,
                      target: "_blank"
                    }, _toDisplayString(certificateData.value?.participant.eventName), 9, _hoisted_8)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "12",
              xs: "12",
              md: "5",
              lg: "5",
              xl: "5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_v_img, {
                    class: "img",
                    src: certificateData.value?.certificateThumbnail
                  }, null, 8, ["src"]),
                  _createVNode(_component_v_btn, {
                    class: "btn",
                    onClick: downloadCertificate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("btnDownload")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})